import {IssueRelativeTime} from '@github-ui/ago'
import {MarkdownViewer} from '@github-ui/markdown-viewer'
import {sanitize} from '@github-ui/sanitize'
import {ScrollableRegion} from '@primer/react/experimental'
import {useMemo} from 'react'

import styles from './ArtifactPanelContent.module.css'

export type ArtifactType = 'plan' | 'link' | 'generic'

export type PanelArtifact = {
  id: string
  type: ArtifactType
  name: string
  body: string
  bodyHTML: string
  updatedAt?: string
  updatedByActor?: {
    login: string
  }
}

type ArtifactPanelBodyProps = {
  artifact: PanelArtifact
}

/** Just the rendered markdown (or plain-text fallback) for an artifact. */
export function ArtifactPanelBody({artifact}: ArtifactPanelBodyProps) {
  const sanitizedHTML = useMemo(() => (artifact.bodyHTML ? sanitize(artifact.bodyHTML) : ''), [artifact.bodyHTML])

  return (
    <ScrollableRegion key={artifact.id} className={styles.Body} aria-label={artifact.name}>
      {artifact.updatedAt && (
        <p className={styles.Metadata}>
          Updated <IssueRelativeTime datetime={artifact.updatedAt} />
          {artifact.updatedByActor && <> by {artifact.updatedByActor.login}</>}
        </p>
      )}
      {sanitizedHTML ? (
        <div className={styles.MarkdownContent}>
          <MarkdownViewer verifiedHTML={sanitizedHTML} />
        </div>
      ) : (
        <pre className={styles.PlainBody}>{artifact.body}</pre>
      )}
    </ScrollableRegion>
  )
}
